// 카테고리 그룹 코드
//    MT1	대형마트
// CS2	편의점
// PS3	어린이집, 유치원
// SC4	학교
// AC5	학원
// PK6	주차장
// OL7	주유소, 충전소
// SW8	지하철역
// BK9	은행
// CT1	문화시설
// AG2	중개업소
// PO3	공공기관
// AT4	관광명소
// AD5	숙박
// FD6	음식점
// CE7	카페
// HP8	병원
// PM9	약국

const placeCode = {
  MT1: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  CS2: {
    title: "편의점",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%ED%8E%B8%EC%9D%98%EC%A0%90.png",
  },
  PS3: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  SC4: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  AC5: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  PK6: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  OL7: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  SW8: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  BK9: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  CT1: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  AG2: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  PO3: {
    title: "기타",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B8%B0%ED%83%80.png",
  },
  AT4: {
    title: "관광명소",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EA%B4%80%EA%B4%91%EC%A7%80.png",
  },
  AD5: {
    title: "숙박",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EC%88%99%EB%B0%95.png",
  },
  FD6: {
    title: "음식점",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EB%A0%88%EC%8A%A4%ED%86%A0%EB%9E%912.png",
  },
  CE7: {
    title: "카페",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EC%B9%B4%ED%8E%98.png",
  },
  HP8: {
    title: "병원",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EB%B3%91%EC%9B%90.png",
  },
  PM9: {
    title: "약국",
    url:
      "https://usecloud.s3-ap-northeast-1.amazonaws.com/kakaoMapIcon/%EC%95%BD%EA%B5%AD.png",
  },
};

export default placeCode;
